__webpack_require__.p = "/class-vs-functions/";